import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import MaintenanceEntryPage from 'src/components/maintenance/MaintenanceEntryPage';
import { MAINTENANCE_ANCHORS } from 'src/constants/maintenance';
import FeaturesContext from 'src/context/FeaturesContext';
import { useToolingStock, useToolingType } from 'src/hooks/services/useToolingStock';
import useQueryParams from 'src/hooks/useQueryParams';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';
import userPropType from 'src/utils/user-prop-type';

const anchor = MAINTENANCE_ANCHORS.tooling_stock;

/**
 * Tool (tooling stock) maintenance entry page — resolves the tool + its type
 * through the tooling resource hooks and defers the loading / not-found gates
 * and the operator flow to the shared MaintenanceEntryPage. Tooling is gated on
 * its own feature flag in addition to equipment maintenance.
 */
const ToolMaintenancePage = ({ user }) => {
  const { uuid } = useParams();
  const { event: initialEventUuid } = useQueryParams();
  const { features } = useContext(FeaturesContext);
  const isEnabled =
    isFeatureEnabled(features, FEATURES.EQUIPMENT_MAINTENANCE) &&
    isFeatureEnabled(features, FEATURES.TOOLING_STOCK);

  const instanceQuery = useToolingStock(uuid, { enabled: isEnabled });
  const typeUri = instanceQuery.data?.[anchor.typeUriField];
  const typeQuery = useToolingType(typeUri, { enabled: isEnabled && Boolean(typeUri) });

  return (
    <MaintenanceEntryPage
      user={user}
      uuid={uuid}
      anchor={anchor}
      isEnabled={isEnabled}
      instanceQuery={instanceQuery}
      typeQuery={typeQuery}
      initialEventUuid={initialEventUuid}
    />
  );
};

ToolMaintenancePage.propTypes = {
  user: userPropType,
};

ToolMaintenancePage.defaultProps = {
  user: null,
};

export default ToolMaintenancePage;
